import React, { useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import { createMuiTheme } from "@material-ui/core/styles";
import TreeView from "@material-ui/lab/TreeView";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import ChevronRightIcon from "@material-ui/icons/ChevronRight";
import ChevronLeftIcon from "@material-ui/icons/ChevronLeft";
import { ThemeProvider } from "@material-ui/styles";
import { useEffect } from "react";
import arrowRound from "../../../Icons/arrowRound.svg";
import RedCross from "../../../Icons/RedCross";
import { withStyles } from "@material-ui/core/styles";
import MuiTreeItem from "@material-ui/lab/TreeItem";
import Snackbar from "@material-ui/core/Snackbar";
import MuiAlert from "@material-ui/lab/Alert";
import CustomizedAlert from "../../Alert/CustomizedAlert";
import { useTranslation } from "react-i18next";
import cloneDeep from "lodash-es/cloneDeep";
import { GetStateFromData } from "../../../components/CustomHooks/CustomHooks";

function Alert(props) {
  return <MuiAlert elevation={6} variant="filled" {...props} />;
}
const theme = createMuiTheme({
  typography: {
    body1: {
      fontFamily: "Open Sans",
      fontWeight: 400,
      fontSize: "13px",
      color: "black",
      lineHeight: 2.3,
    },
  },
  "&.Mui-selected > .MuiTreeItem-content": {
    backgroundColor: "transparent",
  },
  "&.Mui-selected > &.MuiTreeItem-label": {
    backgroundColor: "transparent",
  },
  selected: {
    backgroundColor: "none",
  },
});

const useStyles = makeStyles({
  root: {
    height: 140,
    flexGrow: 1,
    maxWidth: 400,

    "&.Mui-selected": {
      backgroundColor: "transparent",
    },
    "&.Mui-selected > &.MuiTreeItem-label": {
      backgroundColor: "transparent",
    },
    "@global": {
      ".MuiTreeItem-root.Mui-selected > .MuiTreeItem-content .MuiTreeItem-label":
        {
          backgroundColor: "transparent",
        },
      ".MuiTreeItem-root.Mui-selected > .MuiTreeItem-content .MuiTreeItem-label:hover, .MuiTreeItem-root.Mui-selected:focus > .MuiTreeItem-content .MuiTreeItem-label":
        {
          backgroundColor: "transparent",
        },
    },
  },
  selected: {
    backgroundColor: "none",
  },
  "& .MuiTreeItem-root": {},
  buttonStyleActive: {
    "background-color": "rgb(0, 114, 198)",
    display: "flex",
    width: "40px",
    color: "white",
    "align-items": "center",
    "justify-content": "center",
    "font-size": "11px",
    "border-radius": "4px",
    marginRight: "15px",
    marginTop: "2px",
    marginBottom: "2px",
  },
  labelWrapper: {
    display: "flex",
    justifyContent: "space-between",
    backgroundColor: "#FFF !important",
    marginLeft: "-5px",
    "&:hover": {
      backgroundColor: "rgba(63, 81, 181, 0.08)",
    },
  },
  labelContentWrapper: {
    display: "flex",
    alignItems: "center",
  },
  label: {
    color: "#005EA3",
    fontWeight: 600,
  },
  unMapButton: {
    margin: "0px 10px",
    color: "red",
    fontSize: "10px",
    display: "flex",
    paddingTop: "3px",
  },
  unMapText: {
    marginRight:
      window?.psh_configs?.selectedLanguage === "ar" ||
      window?.psh_configs?.selectedLanguage === "ar-SA"
        ? null
        : "5px",
    marginLeft:
      window?.psh_configs?.selectedLanguage === "ar" ||
      window?.psh_configs?.selectedLanguage === "ar-SA"
        ? "5px"
        : null,
  },
});

const TreeItem = withStyles({
  root: {
    "&.Mui-selected": {
      backgroundColor: "transparent",
    },
    "&.Mui-selected > &.MuiTreeItem-label": {
      backgroundColor: "transparent",
    },
    "@global": {
      ".MuiTreeItem-root.Mui-selected > .MuiTreeItem-content .MuiTreeItem-label":
        {
          backgroundColor: "transparent",
        },
      ".MuiTreeItem-root.Mui-selected > .MuiTreeItem-content .MuiTreeItem-label:hover, .MuiTreeItem-root.Mui-selected:focus > .MuiTreeItem-content .MuiTreeItem-label":
        {
          backgroundColor: "transparent",
        },
    },
  },
})(MuiTreeItem);
export default function ServiceTreeView(props) {
  const translationStyles1 =
    window?.psh_configs?.selectedLanguage === "ar" ||
    window?.psh_configs?.selectedLanguage === "ar-SA";
  const { t } = useTranslation();
  const contexts = GetStateFromData();

  const [state, setState] = React.useState({
    open: false,
    vertical: "top",
    horizontal: "center",
  });
  const { vertical, horizontal, open } = state;
  const handleClose = () => {
    setState({ open: false });
  };
  const { dataObjectsContent, currentMappedDO, openCanvasForSubform} = contexts.contexts;
  const classes = useStyles();
  const [responseData, setResponseData] = useState();
  const [servicemapButton, setServiceMapButton] = useState("");
  const [mappedServices, setMappedServices] = useState(new Map([]));
  const [currentNode, setCurrentNode] = useState();
  props.mappedServiceRef.value = props?.rowData?.mappedControls
    ? new Map(Object.entries(JSON.parse(props?.rowData?.mappedControls)))
    : new Map([]);
  useEffect(() => {
    if (props?.rowData?.mappedControls) {
      setMappedServices(
        new Map(Object.entries(JSON.parse(props.rowData.mappedControls)))
      );
    }
  }, []);

  // const [alertMsg, setAlertMsg] = useState("");
  const [alertData, setAlertData] = useState({
    open: false,
    showConfirm: "showNotification"
});

  var arr = [];
  useEffect(() => {
    let response = getReponseParameter(props.data);
    setResponseData(response);
  }, []);

  useEffect(() => {
    if (dataObjectsContent.length > 0) {
      findMappedVariables(dataObjectsContent);
    }
  }, [dataObjectsContent]);

  function getVariable(dataObjectChildren) {
    for (let child of dataObjectChildren) {
      if (child.children) {
        getVariable(child.children);
      } else {
        if (child.treeName) {
          arr.push(child.treeName);
        }
      }
    }
  }

  function findMappedVariables(dataObject) {
    getVariable(dataObject);
    for (let [key, value] of mappedServices) {
      if (!arr.includes(value)) {
        mappedServices.delete(key);
      }
    }
  }

  function handleClick(e, node, type) {
    setServiceMapButton("");
    if (props.dataRef?.value?.Unbounded) {
      setMapButton(e, node, type);
    } else {
      if (
        mappedServices.has(
          `${node.type || type}.${
            node.ParentName ? node.ParentName : node.Name
          }.${node.ParamName ? node.ParamName : node.Name}`
        )
      ) {
        e.stopPropagation();
        return;
      } else {
        // setAlertMsg((prev) => (prev = "Please select a control first."));
        // setState({ open: true });
        setAlertData({
          'open': true,
          'showConfirm':'showNotification',
          'alertType':'info',
          'alertContentMsg': `${t(`Please select a control first.`)}.`,
        })        
        e.stopPropagation();
      }
    }
  }

  function getLevel(node, l) {
    let level = l;
    if (node?.Member) {
      for (let i in node.Member) {
        level++;
        if (node.Member[i].Member) {
          level++;
          getLevel(node.Member[i], level);
        }
      }
    }
    if (node?.children) {
      for (let i in node.children) {
        level++;
        if (node.children[i].children) {
          level++;
          getLevel(node.children[i], level);
        }
      }
    }

    return level;
  }

function parentUnbounded(parentObject) {
  if (parentObject.Unbounded === "Y") {
    return true;
  } else {
    return parentObject.Unbounded === "Y";
  }
}
function findParentForChild(parentName, objects) {
  for (const obj of objects) {
    if (obj.VariableName === parentName || obj?.treeName === parentName) {
      return parentUnbounded(obj);
    } else {
      if (obj.children) {
        for (const child of obj.children) {
          if (child.VariableName === parentName || child?.treeName === parentName) {
            return parentUnbounded(child);
          } else if (child.children) {
            const result = findParentForChild(parentName, child.children);
            if (result !== null) {
              return result;
            }
          }
        }
      }
    }
  }
  return null;
}

function nodeParentUnbounded(parentObject) {
  return parentObject.Unbounded === "Y";
}

const findNodeParentUnbounded = (nodeParentName, dataObjects) => {
  for (const obj of dataObjects) {
    if (obj.ParamName === nodeParentName) {
      return nodeParentUnbounded(obj);
    } else {
      if (obj.Member) {
        for (const member of obj.Member) {
          if (member.ParamName === nodeParentName) {
            return nodeParentUnbounded(member); // Return true/false
          } else if (member.Member) {
            const result = findNodeParentUnbounded(nodeParentName, member.Member);
            if (result !== null) {
              return result; // Return true/false from deeper levels
            }
          }
        }
      }
    }
  }
}

function checkUnboundedForAncestors(data, selectedParamName) {
  let current = data.find(obj => obj.ParamName === selectedParamName);
  
  if (!current) return false;
  
  while (true) {
    if (current.Unbounded !== "N") {
      return false;
    }
  
    if (current.ParentName === 0) {
      break;
    }
    
    current = data.find(obj => obj.ParamName === current.ParentName);
    if (!current) return false;
  }
  return true;
}

function checkUnboundedForAncestors(data, selectedParamName) {
  let current = data.find(obj => obj.ParamName === selectedParamName);
  
  if (!current) return false;
  
  while (true) {
    if (current.Unbounded !== "N") {
      return false;
    }
    if (current.ParentName === 0) {
      break;
    }
    if (Number.isInteger(current.ParentName)) {
      break;
    }
    current = data.find(obj => obj.ParamName === current.ParentName);
    if (!current) return false;
  }
  return true;
}

const mappingStatus = (isDOParentUnbounded, isNodeParentUnbounded) => {
  if (isDOParentUnbounded === true && (isNodeParentUnbounded === undefined || isNodeParentUnbounded === null || isNodeParentUnbounded === false)) {
    return false;
  }
  if (isNodeParentUnbounded === true && (isDOParentUnbounded === undefined || isDOParentUnbounded === null || isDOParentUnbounded === false)) {
    return false;
  }
  if (isDOParentUnbounded === false && (isNodeParentUnbounded === undefined || isNodeParentUnbounded === null || isNodeParentUnbounded === false)) {
    return true;
  }
  if (isNodeParentUnbounded === false && (isDOParentUnbounded === undefined || isDOParentUnbounded === null || isDOParentUnbounded === false)) {
    return true;
  }
  if(isDOParentUnbounded === true && isNodeParentUnbounded === true){
    return true
  }
  return isDOParentUnbounded !== isNodeParentUnbounded;
}

  function setMapButton(e, node, type) {
    let nodeLevel = getLevel(node, 0);
    let controlObj = props.dataRef?.value;
    const isDOParentUnbounded = findParentForChild(props.dataRef?.value?.parentName, dataObjectsContent)
    const isNodeParentUnbounded = findNodeParentUnbounded(node.ParentName, type === "Response" ? props.data.ResponseParameters : props.data.RequestParameters)
    const parentUnbounded = checkUnboundedForAncestors(type === "Response" ? props.data.ResponseParameters : props.data.RequestParameters, node?.ParentName);
    const allowMapping = mappingStatus(isDOParentUnbounded, isNodeParentUnbounded)
    let selectedObjectLevel = getLevel(props.dataRef?.value, 0);
    if (
      (node.ParamName && node.ParamName !== 0 && !controlObj.parentName) ||
      (node.Name && node.Name !== 0 && !controlObj.parentName)
    ) {
      if (
        props.dataRef?.value &&
        node.Unbounded &&
        props.dataRef?.value.Unbounded === node.Unbounded &&
        ((node.Member &&
        props.dataRef?.value.children) || (!isNaN(node.ParentName) && !node?.Member) || (parentUnbounded && allowMapping))
      ) {
        setServiceMapButton(
          `${type}.${
            props.data.serviceType !== "SOAP"
              ? node.ParentName
              : node.ParentName
              ? node.ParentName
              : node.Name
          }.${node.ParamName ? node.ParamName : node.Name}`
        );
        setCurrentNode(node);
      } else {
        setAlertData({
          open: true,
          showConfirm:'showNotification',
          alertType:'info',
          alertContentMsg: "Control cannot be mapped.",
          autoHideDuration: 3000
        })
        // setAlertMsg((prev) => (prev = "Control cannot be mapped."));
        // setState({ open: true });
      }
    } else {
      if (
        props.dataRef?.value &&
        node.Unbounded &&
        props.dataRef?.value.Unbounded === node.Unbounded &&
        (nodeLevel === selectedObjectLevel) && allowMapping
      ) {
        setServiceMapButton(
          `${type}.${
            props.data.serviceType !== "SOAP"
              ? node.ParentName
              : node.ParentName
              ? node.ParentName
              : node.Name
          }.${node.ParamName ? node.ParamName : node.Name}`
        );
        setCurrentNode(node);
      } else if (
        props.dataRef?.value &&
        node.Unbounded &&
        props.dataRef?.value.Unbounded === node.Unbounded &&
        node.Member &&
        props.dataRef?.value.children
      ) {
        setServiceMapButton(
          `${type}.${
            props.data.serviceType !== "SOAP"
              ? node.ParentName
              : node.ParentName
              ? node.ParentName
              : node.Name
          }.${node.ParamName ? node.ParamName : node.Name}`
        );
        setCurrentNode(node);
      } else {
        setAlertData({
          open: true,
          showConfirm:'showNotification',
          alertType:'info',
          alertContentMsg: "Control cannot be mapped.",
          autoHideDuration: 3000
        })
      }
    }
  }

  function setfilter(data, paramScope) {
    return data.map((item) => {
      const newItem = {
        ...item,
        ...(currentNode.Name === item.Name
          ? { MappedControl: props.dataRef?.value.treeName }
          : {}),
        paramName: item.Name,
        unbounded: item.Unbounded,
        paramType: item.Type,
        paramScope: paramScope,
        ...(item.Member
          ? { Variable: item?.Member }
          : { Variable: item?.Variable }),
        Variable: item.Member
          ? setfilter(item.Member, paramScope)
          : item.Variable
          ? setfilter(item.Variable, paramScope)
          : [],
      };
      delete newItem.Member;
      return newItem;
    });
  }

  function deletefilter(data, current) {
    let result = data.map((item) => {
      const itemCopy = cloneDeep(item || null);
      if (current.Name === itemCopy.Name) {
        delete itemCopy.MappedControl;
      }
      return {
        ...itemCopy,
        Variable: itemCopy.Variable
          ? deletefilter(itemCopy.Variable, current)
          : [],
      };
    });
    return result;
  }
  function handleMapping(node, type, event) {
    const isParentMapped = checkMappedParent(node)
    const parentUnbounded = checkUnboundedForAncestors(type === "Response" ? props.data.ResponseParameters : props.data.RequestParameters, currentNode?.ParentName);
    const hasParent = props.dataRef?.value?.parentName &&  !props.dataRef?.value?.isParentTable
    const unMappedNonArray = hasParent && parentUnbounded && isParentMapped
    const mapSystemVariable = !hasParent && parentUnbounded
    if(isParentMapped || !isNaN(currentNode?.ParentName) || unMappedNonArray || mapSystemVariable){
    mappedServices.set(node, props.dataRef?.value.treeName);
    var setObj;
    if (props.data.serviceType !== "SOAP") {
      if (currentNode.Member) {
        setObj = {
          paramName: currentNode?.ParamName,
          unbounded: currentNode?.Unbounded,
          paramType: currentNode?.ParamType,
          scope: currentNode.ParamScope ? currentNode.ParamScope : "",
          mappedControl: props.dataRef?.value.treeName,
          Variable: [],
          parentName: currentNode?.ParentName,
          parentId: currentNode?.ParentID,
        };
      } else {
        setObj = {
          paramName: currentNode?.ParamName,
          unbounded: currentNode?.Unbounded,
          paramType: currentNode?.ParamType,
          scope: currentNode.ParamScope ? currentNode.ParamScope : "",
          mappedControl: props.dataRef?.value.treeName,
          parentName: currentNode?.ParentName,
          parentId: currentNode?.ParentID,
        };
      }

      if (type === "Response") {
        let mappedArr = handleMapWebServices(props.rowData.Parameters.ResponseParameters.Variable, setObj, currentNode?.ParentName)
        let isIndex = isDataPresent(props.rowData.Parameters.ResponseParameters.Variable, currentNode?.ParentName)
  
        if (isIndex) {
          props.rowData.Parameters.ResponseParameters.Variable = mappedArr
        } else {
          props.rowData.Parameters.ResponseParameters.Variable.push(setObj);
        }
      } else {
         //checking parentname
         let mappedArr = handleMapWebServices(props.rowData.Parameters.InputParameters.Variable, setObj, currentNode?.ParentName)
         let isIndex = isDataPresent(props.rowData.Parameters.InputParameters.Variable, currentNode?.ParentName)
   
         if (isIndex) {
           props.rowData.Parameters.InputParameters.Variable = mappedArr
         } else {
           props.rowData.Parameters.InputParameters.Variable.push(setObj);
         }
      }
    } else {
      if (type === "Response") {
        let copyRequestParam = [...props.data.ResponseParameters];
        if (props.rowData.Parameters.ResponseParameters.Variable.length === 0) {
          props.rowData.Parameters.ResponseParameters.Variable = setfilter(
            copyRequestParam,
            copyRequestParam[0].ParamScope
          );
        } else {
          props.rowData.Parameters.ResponseParameters.Variable = setfilter(
            props.rowData.Parameters.ResponseParameters.Variable,
            copyRequestParam[0].ParamScope
          );
        }
      } else {
        let copyRequestPam = [...props.data.RequestParameters];
        if (props.rowData.Parameters.InputParameters.Variable.length === 0) {
          props.rowData.Parameters.InputParameters.Variable = setfilter(
            copyRequestPam,
            copyRequestPam[0].ParamScope
          );
        } else {
          props.rowData.Parameters.InputParameters.Variable = setfilter(
            props.rowData.Parameters.InputParameters.Variable,
            copyRequestPam[0].ParamScope
          );
        }
      }
    }
    setServiceMapButton((prev) => (prev = ""));
    props.rowData.mappedControls = JSON.stringify(
      Object.fromEntries(mappedServices)
    );
    event.stopPropagation();   
  }else{
    setAlertData({
      open: true,
      showConfirm:'showNotification',
      alertType:'info',
      alertContentMsg: "Please map the parent data object before proceeding with the nested variable",
      autoHideDuration: 3000
    })
  }
  }

  const checkMappedParent = (node) => {
      let curParent = currentNode?.ParentName
      for(let [key, value] of mappedServices){
        let treeParentName = props?.dataRef?.value?.treeName?.split(".")
        treeParentName.splice(treeParentName?.length - 1)
        const treeParent = treeParentName?.join(".")
        if(((key.split(".")[key.split(".").length - 1]) === curParent) && (value === treeParent)){
          return true
        }
      }
      return false
  }

  const handleMapWebServices = (node, setObj, parentName) => {
    const result = [...node];
    for (let i = 0; i < result.length > 0; i++) {
      if (result[i].paramName === parentName) {
        result[i].Variable.push(setObj);
      }
      if (result[i].Variable && result[i].Variable?.length > 0) {
        result[i].Variable?.forEach((nodeChild) => {
          handleMapWebServices(
            Array.isArray(nodeChild) ? nodeChild : [nodeChild],
            setObj,
            parentName
          );
        });
      }
    }
    return result;
  };

  const isDataPresent = (arr, target) => {
    return arr.some((item) => {
      if (item.paramName === target) {
        return true;
      } else if (Array.isArray(item?.Variable)) {
        return isDataPresent(item?.Variable, target);
      }
      return false;
    });
  };

  function unMapParameter(node, type, current, event) {
    mappedServices.delete(node);
    if (props.data.serviceType !== "SOAP") {
      if (type === "Response") {
        let arrToUnmap = [...props.rowData.Parameters.ResponseParameters.Variable]
        const isUnmapped = handleUnmapWebServices(arrToUnmap, current?.ParamName)
        if(isUnmapped)
          props.rowData.Parameters.ResponseParameters.Variable = [...arrToUnmap];
      } else {
        let arrToUnmap = [...props.rowData.Parameters.InputParameters.Variable]
        const isUnmapped = handleUnmapWebServices(arrToUnmap, current?.ParamName)
        if(isUnmapped)
          props.rowData.Parameters.InputParameters.Variable = [...arrToUnmap];
      }
    } else {
      if (type === "Response") {
        const arr = deletefilter(
          props.rowData.Parameters.ResponseParameters.Variable,
          current
        );
        props.rowData.Parameters.ResponseParameters.Variable = [...arr];
      } else {
        const arr = deletefilter(
          props.rowData.Parameters.InputParameters.Variable,
          current
        );
        props.rowData.Parameters.InputParameters.Variable = [...arr];
      }
    }
    props.rowData.mappedControls = JSON.stringify(
      Object.fromEntries(mappedServices)
    );
    setServiceMapButton("");
    // setAlertMsg((prev) => (prev = "Please select a control first."));
    setAlertData({
      open: false,
      showConfirm:'showNotification',
      alertType:'info',
      alertContentMsg: `${t(`Please select a control first.`)}.`,
    })
    // setState({ open: false });
    event.stopPropagation();
  }

  function handleUnmapWebServices(node, parentName) {
    for (let i = 0; i < node.length; i++) {
      if (node[i]["paramName"] === parentName) {
        node.splice(i, 1);
        return true;
      } else if (Array.isArray(node[i].Variable)) {
        if (handleUnmapWebServices(node[i].Variable, parentName)) {
          return true;
        }
      }
    }
    return false; // Node with parameter value not found
  }

  const renderTree = (nodes, type) =>
    props.data.serviceType !== "SOAP" ? (
      <ThemeProvider theme={theme}>
        <TreeItem
          key={`${nodes.type || type}.${nodes?.ParentName}.${nodes?.ParamName}`}
          nodeId={`${nodes.type || type}.${nodes?.ParentName}.${
            nodes?.ParamName
          }`}
          label={
            <div
              className={classes.labelWrapper}
              onClick={(e) => handleClick(e, nodes, nodes?.type || type)}
            >
              <div className={classes.labelContentWrapper}>
                <span>{t(`${nodes?.ParamName}`)}</span>
                {mappedServices.get(
                  `${nodes.type || type}.${nodes?.ParentName}.${
                    nodes?.ParamName
                  }`
                ) ? (
                  <>
                    <img
                      style={{ marginLeft: "15px", marginRight: "15px" }}
                      src={arrowRound}
                      width={15}
                      height={15}
                      alt={"round arrow icon"}
                    />
                    <span className={classes.label}>
                      {mappedServices.get(
                        `${nodes.type || type}.${nodes?.ParentName}.${
                          nodes?.ParamName
                        }`
                      )}
                    </span>
                  </>
                ) : null}
              </div>
              {servicemapButton ===
                `${nodes.type || type}.${nodes?.ParentName}.${
                  nodes?.ParamName
                }` &&
              !mappedServices.has(
                `${nodes.type || type}.${nodes?.ParentName}.${nodes?.ParamName}`
              ) ? (
                <div
                  className={classes.buttonStyleActive}
                  onClick={(event) =>
                    handleMapping(
                      `${nodes.type || type}.${nodes?.ParentName}.${
                        nodes?.ParamName
                      }`,
                      type,
                      event
                    )
                  }
                >
                  {t("Map")}
                </div>
              ) : null}

              {mappedServices.has(
                `${nodes.type || type}.${nodes?.ParentName}.${nodes?.ParamName}`
              ) ? (
                <span
                  className={classes.unMapButton}
                  onClick={(event) =>
                    unMapParameter(
                      `${nodes.type || type}.${nodes?.ParentName}.${
                        nodes?.ParamName
                      }`,
                      type,
                      nodes,
                      event
                    )
                  }
                >
                  {" "}
                  <span className={classes.unMapText}>{t("UnMap")}</span>{" "}
                  <RedCross />{" "}
                </span>
              ) : null}
            </div>
          }
        >
          {Array.isArray(nodes.Member)
            ? nodes.Member.map((node) => renderTree(node, nodes?.type || type))
            : null}
        </TreeItem>
      </ThemeProvider>
    ) : (
      <ThemeProvider theme={theme}>
        <TreeItem
          key={`${nodes.type || type}.${
            nodes.ParentName ? nodes.ParentName : nodes.Name
          }.${nodes.ParamName ? nodes.ParamName : nodes.Name}`}
          nodeId={`${nodes.type || type}.${
            nodes.ParentName ? nodes.ParentName : nodes.Name
          }.${nodes.ParamName ? nodes.ParamName : nodes.Name}`}
          label={
            <div
              className={classes.labelWrapper}
              onClick={(e) => handleClick(e, nodes, nodes?.type || type)}
            >
              <div className={classes.labelContentWrapper}>
                <span>{nodes.ParamName ? nodes.ParamName : nodes.Name}</span>
                {mappedServices.get(
                  `${nodes.type || type}.${
                    nodes.ParentName ? nodes.ParentName : nodes.Name
                  }.${nodes.ParamName ? nodes.ParamName : nodes.Name}`
                ) ? (
                  <>
                    <img
                      style={{ marginLeft: "15px", marginRight: "15px" }}
                      src={arrowRound}
                      width={15}
                      height={15}
                      alt={"round arrow icon"}
                    />
                    <span className={classes.label}>
                      {mappedServices.get(
                        `${nodes.type || type}.${
                          nodes.ParentName ? nodes.ParentName : nodes.Name
                        }.${nodes.ParamName ? nodes.ParamName : nodes.Name}`
                      )}
                    </span>
                  </>
                ) : null}
              </div>
              {servicemapButton ===
                `${nodes.type || type}.${
                  nodes.ParentName ? nodes.ParentName : nodes.Name
                }.${nodes.ParamName ? nodes.ParamName : nodes.Name}` &&
              !mappedServices.has(
                `${nodes.type || type}.${
                  nodes.ParentName ? nodes.ParentName : nodes.Name
                }.${nodes.ParamName ? nodes.ParamName : nodes.Name}`
              ) ? (
                <div
                  className={classes.buttonStyleActive}
                  onClick={(event) =>
                    handleMapping(
                      `${nodes.type || type}.${
                        nodes.ParentName ? nodes.ParentName : nodes.Name
                      }.${nodes.ParamName ? nodes.ParamName : nodes.Name}`,
                      type,
                      event
                    )
                  }
                >
                  {t("Map")}
                </div>
              ) : null}

              {mappedServices.has(
                `${nodes.type || type}.${
                  nodes.ParentName ? nodes.ParentName : nodes.Name
                }.${nodes.ParamName ? nodes.ParamName : nodes.Name}`
              ) ? (
                <span
                  className={classes.unMapButton}
                  onClick={(event) =>
                    unMapParameter(
                      `${nodes.type || type}.${
                        nodes.ParentName ? nodes.ParentName : nodes.Name
                      }.${nodes.ParamName ? nodes.ParamName : nodes.Name}`,
                      type,
                      nodes,
                      event
                    )
                  }
                >
                  {" "}
                  <span className={classes.unMapText}>{t("UnMap")}</span>{" "}
                  <RedCross />{" "}
                </span>
              ) : null}
            </div>
          }
        >
          {Array.isArray(nodes.Member)
            ? nodes.Member.map((node) => renderTree(node, nodes?.type || type))
            : null}
        </TreeItem>
      </ThemeProvider>
    );

  return (
    <>
      <TreeView
        className={classes.root}
        defaultCollapseIcon={<ExpandMoreIcon />}
        defaultExpanded={["root"]}
        defaultExpandIcon={
          translationStyles1 ? <ChevronLeftIcon /> : <ChevronRightIcon />
        }
      >
        {renderTree({
          id: "root1",
          ParamName: "Request Parameters",
          ParentName: "root1",
          Member: props.data.RequestParameters,
          type: "Request",
        })}
        {renderTree({
          id: "root",
          ParamName: "Response Parameters",
          ParentName: "root",
          Member: props.data.ResponseParameters,
          type: "Response",
        })}
      </TreeView>
      {/* <div style={{ position: "absolute" }}>
        <Snackbar
          anchorOrigin={{ vertical: "top", horizontal: "center" }}
          style={{top:"16px"}}
          open={open}
          onClose={handleClose}
          key={vertical + horizontal}
        >
          <Alert
            severity="info"
            style={{
              width: "290px",
              backgroundColor: "#fae18e",
              color: "#000000",
              fontFamily: "Open Sans",
              fontSize: "13px",
            }}
          >
            {alertMsg}
          </Alert>
        </Snackbar>
      </div> */}
      {
        alertData.open === true && <CustomizedAlert alertData={alertData} />
      }
    </>
  );
}

function getReponseParameter(data) {
  let newObj = {
    id: "root",
    ParamName: "Response Parameters",
    Member: data.ResponseParameters,
  };

  return newObj;
}
